import { FeatureFlag } from '@ps/web-core-enums';
import type { HgClubInfo } from '@ps/web-shared-api-types/v0/SwHomeGames';
import { Link } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import CoachMark from '@swf/components/CoachMark/CoachMark';
import useFeature from '@swf/core/hooks/useFeature';
import type { RootState } from '@swf/core/store';
import { useHomeGamesWidget } from '@swf/poker';

import { ClubRoute, HGOnboarding, UserClubRole } from '../../../types/common';
import JoinedFirstClub from '../../CoachMark/JoinClub/JoinedFirstClub';

import styles from './SidebarNav.scss';

interface Props {
  club: HgClubInfo;
  index: number;
}

const SidebarNavClubItem = ({ club: { clubName, clubId, roleForUser }, index }: Props) => {
  const { widgetDispatch, widgetSelect } = useHomeGamesWidget();
  const hasGames = useSelector(widgetSelect.hasGames);
  const isLobbyPage = window.location.href.includes(`/${ClubRoute.Lobby}`);
  const isMember = roleForUser === UserClubRole.Member;
  const joinClubOBEnabled = useFeature(FeatureFlag.PKRHomeGamesOnboardingJoinClub);
  const joinClubOnboardingCompleted = useSelector((rootState: RootState) =>
    widgetSelect.localStorageItem(rootState, `onboarding[${HGOnboarding.JoinClub}]`)
  );
  const showCoachMark =
    !joinClubOnboardingCompleted &&
    !hasGames &&
    isLobbyPage &&
    index === 0 &&
    joinClubOBEnabled &&
    isMember;
  const handleCoachMarkDismiss = () =>
    widgetDispatch.setLocalStorageItem({
      onboarding: { [HGOnboarding.JoinClub]: true }
    });

  const content = (
    <Link alias="homeGamesClubs" values={{ clubId, section: ClubRoute.Lobby }}>
      <div className={styles.clubName} title={clubName}>
        {clubName}
      </div>
    </Link>
  );

  return showCoachMark ? (
    <CoachMark
      onClickAway={handleCoachMarkDismiss}
      content={
        <JoinedFirstClub
          className={styles.coachMark}
          onDismiss={handleCoachMarkDismiss}
          clubName={`${clubName}`}
        />
      }
      placement="right"
    >
      {content}
    </CoachMark>
  ) : (
    content
  );
};

export default SidebarNavClubItem;
